import React, { useEffect, useState, useMemo } from "react";
import BasicTable from "../Components/Global_Components/reacttable/table";
import "../styles/Patients.scss";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  patientid,
  sidebar,
  reportViewId,
  reportViewType,
} from "../Redux/Slice/rootSlice";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import Swal from "sweetalert2";
import { getPatientsReportDatas } from "../Redux/Thunk/Actions";
import AddPatient_form from "../Components/AddPatient_form";
import EditPatient_form from "../Components/EditPatient_form";
import PrescriptionType_PopUp from "../Components/PrescriptionType_PopUp";
import SpermPrescriptionType_PopUp from "../Components/SpermPrescriptionType_PopUp";

function PatientTemplates({
  loaderchange,
  enableditview,
  popupalert,
  popuptext,
}) {
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [update, setUpdate] = useState("");
  const viewpatient = useNavigate();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const createpageReport = useSelector(
    (state) => state.counter.patientReportCreateredux
  );
  const [branches, setbranches] = useState("0");
  const [alert, setalert] = useState(false);
  const edituser = useSelector((state) => state.counter.edituser);
  const adminuser = useNavigate();
  const [changeAlert, setChangeAlert] = useState(false);
  // const [roledata, setroledata] = useState("");
  const roledata = "Super Admin";
  const [closeCreatePopup, setCloseCreatePopup] = useState(false);
  const [closeEditPopup, setCloseEditPopup] = useState(false);
  const [error, seterror] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [search, setsearch] = useState(false);
  const [selectedFilterType, setSelectedFiltype] = useState("all");
  const [patientReportCreate, setPatientReportCreate] =
    useState(createpageReport);
  const dropdownhandlechange = (e, event) => {
    if (e) {
      dispatch(reportViewType("Patient Reports"));
      viewpatient("/reportview");
      dispatch(reportViewId(e));
      // console.log(e,"id");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const dataPayload = {
        page: dtpageindex,
        page_size: dtpagesize,
        ...(selectedFilterType !== "all" && {
          template_type: selectedFilterType,
        }),
        // search: searchQuery,
        // branch: branches,
      };
      loaderchange("true");
      const patentDetails = getPatientsReportDatas(dataPayload);
      const responsePatentDetails = await dispatch(patentDetails);
      if (responsePatentDetails?.payload?.status?.code === 200) {
        setdatacount(responsePatentDetails.payload.total_count);
        settableheaderdata(responsePatentDetails.payload.data.data);
        loaderchange("false");
        setUpdate(false);
      } else {
        loaderchange("false");
        popupalert("true");
        popuptext("No Data Available");
        setTimeout(() => {
          popupalert("false");
        }, 2000);
      }
    };
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        fetchData();
      }
    } else {
      fetchData();
    }
  }, [
    dtpageindex,
    dtpagesize,
    search,
    searchQuery,
    branches,
    update,
    selectedFilterType,
  ]);

  const columns = useMemo(
    () => [
      {
        Header: "Patient Name",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(row.row.original.patient_name)}
                >
                  {row.row.original.patient_id != null
                    ? row.row.original.patient_id.titles +
                      "." +
                      row.row.original.patient_id.first_name +
                      row.row.original.patient_id.last_name
                    : "--"}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Created by",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(
                    row.row.original.user_id.user_name
                  )}
                >
                  {String(row.row.original.user_id.user_name)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Date",
        accessor: "",
        Cell: (row) => {
          const final_value = row.row.original.created_at.slice(0, 10);
          const [year, month, day] = final_value.split("-");
          const formattedDate = `${day}-${month}-${year}`;
          // console.log(formattedDate);
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(formattedDate)}
                >
                  {String(formattedDate)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Time",
        accessor: "",
        Cell: (row) => {
          // const inputDateTime = "2023-11-08T07:35:00.730468Z";
          // const date = new Date(inputDateTime);
          // const hours = date.getHours();
          // const minutes = date.getMinutes();
          // const formattedHours = hours.toString().padStart(2, "0");
          // const formattedMinutes = minutes.toString().padStart(2, "0");
          // const time = `${formattedHours}:${formattedMinutes}`;
          const date = new Date(row.row.original.created_at);
          const hours = date.getHours();
          const minutes = date.getMinutes();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          let formattedHours = (hours % 12).toString().padStart(2, "0");
          formattedHours = formattedHours === "00" ? "12" : formattedHours;
          const formattedMinutes = minutes.toString().padStart(2, "0");
          const time = `${formattedHours}:${formattedMinutes} ${amOrPm}`;
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(time)}
                >
                  {String(time)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Report type",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>{row.row.original.template_type}</span>
            </>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <div className="style">
              {/* <button
                type="button"
                class="btn btn-danger btn-sm delete"
                style={{ display: "flex", gap: "4px" }}
                onClick={(e) => editPatientPopup(row.row.original.id, e)}
              >
                <i
                  onClick={(e) => editPatientPopup(row.row.original.id, e)}
                  class="bi bi-pencil"
                ></i>{" "}
                Edit
              </button> */}
              <button
                type="button"
                class="btn btn-danger btn-sm delete"
                style={{ display: "flex", gap: "4px" }}
                onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
              >
                <i
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                  class="bi bi-eye-fill"
                ></i>{" "}
                View
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const createPatientReport = (e) => {
    // setPatientReportCreate(true)
    // dispatch(patientReportCreateredux(true))
    navigate("/reportcreate");
  };
  const editPatientPopup = (e) => {
    dispatch(patientid(e));
    setCloseEditPopup(true);
  };

  const [finalPatientsData, setFinalPatientsData] = useState("");

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const patientId = useSelector((state) => state.counter.patientid);
  const [typePrescriptionPopUp, setTypePrescriptionPopUp] = useState(false);

  const handleAddPrescription = () => {
    setTypePrescriptionPopUp(!typePrescriptionPopUp);
  };

  return (
    <div
      className={
        sideactive ? "maincontainer-patient-sa" : "maincontainer-patient"
      }
    >
      {closeCreatePopup && (
        // eslint-disable-next-line react/jsx-pascal-case
        <AddPatient_form
          setCloseCreatePopup={setCloseCreatePopup}
          loaderchange={loaderchange}
          popupalert={popupalert}
          popuptext={popuptext}
          setUpdate={setUpdate}
        />
      )}
      {closeEditPopup && (
        // eslint-disable-next-line react/jsx-pascal-case
        <EditPatient_form
          setCloseEditPopup={setCloseEditPopup}
          loaderchange={loaderchange}
          popupalert={popupalert}
          popuptext={popuptext}
          setUpdate={setUpdate}
        />
      )}
      <div className="patient-header">
        <div className="row">
          <div className="col">
            <h3 className="page-title">Patient Templates</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a
                  href="/"
                  style={{ textDecoration: "none", color: "black" }}
                  onClick={(e) => {
                    dispatch(sidebar("DashBoard"));
                  }}
                >
                  Dashboard
                </a>
              </li>
              <li className="breadcrumb-item active">Patient Templates</li>
            </ul>
          </div>
        </div>
        {/* <div className="add_btn">
          <button onClick={(e) => createPatientReport(e)} className="btn_1">
            Add
          </button>
        </div> */}
        <div className="row">
          <div className="buttonHeader">
            <button
              className="addPatientRecordbtn"
              onClick={handleAddPrescription}
            >
              Create Report
            </button>
          </div>
        </div>
      </div>
      <div className="row" style={{ marginTop: 20 }}>
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="patient">
                <div className="table-content-patient">
                  <form
                    onSubmit={handleSubmit}
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div
                      class="input-group rounded"
                      style={{ width: "250px", height: "40px" }}
                    >
                      <input
                        type="search"
                        class="form-control rounded"
                        aria-label="Search"
                        aria-describedby="search-addon"
                        value={searchQuery}
                        style={{
                          height: "40px",
                        }}
                        onKeyDown={(e) => {
                          if (e.target.value.length === 0 && e.which === 32) {
                            e.preventDefault();
                          }
                        }}
                        onInput={(e) => {
                          if (e.target.value.length <= "100") {
                            setSearchQuery(e.target.value);
                          } else {
                            e.preventDefault();
                          }
                        }}
                        // onKeyDown={(e)=>{if(e.which=="32"){
                        //   e.preventDefault()
                        // }}}

                        min="0"
                        max="10"
                        label="Search"
                        placeholder="Search..."
                        required
                      />

                      <span
                        class="input-group-text border-0 bg-transparent p-0"
                        id="search-addon"
                      >
                        <i
                          class="bi bi-search"
                          style={{
                            color: "#1b5a90",
                            width: "20px",
                            height: "20px",
                            marginLeft: "10px",
                          }}
                        ></i>
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <label htmlFor="type">Filter</label>
                      <select
                        id="type"
                        name="type"
                        value={selectedFilterType}
                        // onChange={(e) => handleDropChanges(e)}
                        className="form-select"
                        selected="selected"
                        onChange={(e) => {
                          // console.log(
                          //   e,
                          //   "setSelectedFiltypesetSelectedFiltypesetSelectedFiltype"
                          // );
                          setSelectedFiltype(e.target.value);
                        }}
                      >
                        <option value="" disabled selected>
                          Select report
                        </option>
                        <option value="all">All</option>
                        <option value="Sperm Report">Sperm Report</option>
                        <option value="DFI Report">DFI Report</option>
                        <option value="IUI Report">IUI Report</option>
                      </select>
                    </div>
                  </form>

                  <div className="table-patient">
                    <BasicTable
                      columns={columns}
                      data={tableheaderdata}
                      pagesize={pagesize}
                      pageindex={pageindex}
                      dtpagesize={dtpagesize}
                      dtpageindex={dtpageindex}
                      datacount={datacount}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReactTooltip
        id="my-tooltip"
        arrowColor="transparent"
        place="bottom-start"
        delayShow={200}
        style={{
          backgroundColor: "#707070",
          fontSize: "10px",
          textAlign: "center",
          padding: "5px",
          fontWeight: 400,
        }}
      />
      {typePrescriptionPopUp && (
        <SpermPrescriptionType_PopUp
          setTypePrescriptionPopUp={setTypePrescriptionPopUp}
        />
      )}
    </div>
  );
}

export default PatientTemplates;
